import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../../plugins/i18n'

const base = 'vehicle-types'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `${base}.create`,
  path: `/${base}/create`,
  component: () => import('./Create.vue'),
  meta: {
    auth: true,
  },
})
  AdminRouter.addRoute({
  name: `${base}.edit`,
  path: `/${base}/:id`,
  component: () => import('./Edit.vue'),
  meta: {
    auth: true,
  },
})

// AdminSidebar.pushItem({
//   id: `${base}`,
//   order: 60,
//   header: $vm => $vm.$t(`general.menu_management`),
//   text($vm) {
//     return $vm.$t(`${base}.title`)
//   },
//   route: {
//     name: `${base}`,
//   },
//   icon: 'icon-car2',
//   permission: 'administer',
// })

messageGroups.push(base)
messageGroups.push('rate')
